/* «¿Funciona en mi camioneta?»: vehículo + carpa + color → imagen a escala + resultado.
   La imagen nueva se funde sobre la anterior (sin parpadeo) y se precargan las del vehículo elegido. */
(() => {
  const TENTS = {
    forest: { name: 'Forest', kg: 60, colors: [['verde', 'Verde'], ['marron', 'Marrón']] },
    wild: { name: 'Wild', kg: 55, colors: [['verde', 'Verde'], ['gris', 'Gris']] },
    everest: { name: 'Everest', kg: 70, colors: [['gris', 'Gris']] }
  };
  const VERDICT = {
    yes: ['ok', 'Sí, es compatible'],
    cond: ['cond', 'Compatible, con condiciones'],
    ask: ['ask', 'Consultanos antes de comprar']
  };
  const cache = new Map();
  const load = (src) => {
    if (!cache.has(src)) cache.set(src, new Promise((res) => { const i = new Image(); i.onload = i.onerror = () => res(i); i.src = src; }));
    return cache.get(src);
  };

  document.querySelectorAll('[data-pk-fit]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const images = JSON.parse(root.querySelector('[data-fit-images]').textContent);
    const stage = root.querySelector('[data-fit-view]') || root.querySelector('.pk-fit__stage');
    let img = root.querySelector('[data-fit-img]');
    const caption = root.querySelector('[data-fit-caption]');
    const colorsBox = root.querySelector('[data-colors]');
    const verdict = root.querySelector('[data-verdict]');
    let color = null;
    let pos = 'caja';
    const posBox = root.querySelector('[data-positions]');
    const posHint = root.querySelector('[data-pos-hint]');
    const POS = {
      caja: ['Caja alta', 'Sobre un rack en la caja, a la altura del techo de la cabina.'],
      baja: ['Caja baja', 'Apoyada directamente sobre las barandas de la caja: cerrada, queda casi al ras del techo de la cabina.'],
      techo: ['Techo', 'Sobre barras en el techo de la cabina: la caja queda libre para la carga.']
    };
    const allowed = (veh, tk) => (veh?.dataset.kind === 'suv' ? ['techo'] : tk === 'everest' ? ['techo', 'caja'] : ['techo', 'caja', 'baja']);
    const drawPositions = () => {
      const veh = checked('pk-fit-veh');
      const list = allowed(veh, tentKey());
      if (!list.includes(pos)) pos = list.includes('caja') ? 'caja' : list[0];
      const SUB = { techo: 'Barras sobre la cabina', caja: 'Rack a la altura del techo', baja: 'Apoyada sobre la caja' };
      const thumb = (k) => {
        const base = `${veh?.value}|${tentKey()}|${color}`;
        return (veh?.dataset.kind !== 'suv' && k !== 'caja' && images[`${base}|${k}`]) || images[base] || '';
      };
      posBox.innerHTML = list.map((k) => `<button type="button" role="radio" class="pk-fit__pos${k === pos ? ' is-on' : ''}" data-pos="${k}" aria-checked="${k === pos}"><span class="pk-fit__pos-thumb" aria-hidden="true" style="background-image:url('${thumb(k)}')"></span><span class="pk-fit__pos-txt"><span class="pk-cond">${POS[k][0]}</span><span class="pk-fit__pos-sub">${veh?.dataset.kind === 'suv' ? 'Barras transversales' : SUB[k]}</span></span></button>`).join('');
      posHint.textContent = veh?.dataset.kind === 'suv' ? `En un SUV la carpa va siempre en el techo, sobre barras transversales.` : POS[pos][1];
    };
    posBox?.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pos]');
      if (!b || b.dataset.pos === pos) return;
      pos = b.dataset.pos;
      drawPositions();
      render();
    });
    posBox?.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
      e.preventDefault();
      const btns = [...posBox.querySelectorAll('[data-pos]')];
      const i = btns.findIndex((b) => b.dataset.pos === pos);
      const n = btns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + btns.length) % btns.length];
      pos = n.dataset.pos; drawPositions(); render();
      posBox.querySelector(`[data-pos="${pos}"]`)?.focus();
    });
    let token = 0;
    const checked = (name) => root.querySelector(`input[name^="${name}"]:checked`);
    const tentKey = () => root.dataset.locked || checked('pk-fit-tent')?.value || 'forest';

    const preload = (veh) => Object.keys(images).filter((k) => k.startsWith(veh + '|') && k.split('|').length === 3).forEach((k) => load(images[k]));

    const swap = async (src, alt) => {
      const my = ++token;
      if (img.getAttribute('src') === src) { img.alt = alt; return; }
      await load(src);
      if (my !== token) return;
      const next = img.cloneNode();
      next.src = src; next.alt = alt;
      next.classList.add('is-entering');
      img.parentNode.insertBefore(next, img.nextSibling);
      requestAnimationFrame(() => requestAnimationFrame(() => next.classList.remove('is-entering')));
      const old = img; img = next;
      setTimeout(() => old.remove(), 420);
    };

    const drawColors = () => {
      const t = TENTS[tentKey()];
      if (!t.colors.some(([k]) => k === color)) color = t.colors[0][0];
      colorsBox.innerHTML = t.colors.length > 1
        ? '<span class="pk-mono">Color</span>' + t.colors.map(([k, label]) =>
          `<button type="button" class="pk-fit__color${k === color ? ' is-on' : ''}" data-color="${k}" aria-pressed="${k === color}">${label}</button>`).join('')
        : '';
    };

    const render = () => {
      const veh = checked('pk-fit-veh');
      if (!veh) return;
      const tk = tentKey();
      const t = TENTS[tk];
      const tentInput = root.querySelector(`input[name^="pk-fit-tent"][value="${tk}"]`);
      if (posBox) drawPositions();
      const suvVeh = veh.dataset.kind === 'suv';
      const src = images[`${veh.value}|${tk}|${color}${!suvVeh && pos !== 'caja' ? '|' + pos : ''}`] || images[`${veh.value}|${tk}|${color}`];
      if (src) swap(src, `Carpa ${t.name} colocada sobre ${veh.dataset.name} (ilustración a escala)`);
      caption.textContent = `${t.name} sobre ${veh.dataset.name}${suvVeh ? '' : ' · ' + POS[pos][0].toLowerCase()}`;
      const [cls, label] = VERDICT[veh.dataset[tk]] || VERDICT.ask;
      const badge = root.querySelector('[data-badge]');
      badge.className = `pk-fit__badge is-${cls}`;
      badge.textContent = label;
      const suv = veh.dataset.kind === 'suv';
      const why = {
        ok: suv || pos === 'techo' ? `La ${t.name} va sobre barras de techo transversales en la ${veh.dataset.name}.` : pos === 'baja' ? `La ${t.name} va apoyada directamente sobre las barandas de la caja de la ${veh.dataset.name}.` : `La ${t.name} va sobre un rack de caja a la altura de la cabina en la ${veh.dataset.name}.`,
        cond: `La ${t.name} se puede colocar en la ${veh.dataset.name} verificando el límite de carga dinámica del techo (la carpa pesa unos ${t.kg} kg).`,
        ask: `La ${t.name} está pensada para vehículos de mayor porte tipo 4x4. Para la ${veh.dataset.name} lo vemos con vos antes de comprar.`
      }[cls];
      root.querySelector('[data-why]').textContent = why + (veh.dataset.note ? ' ' + veh.dataset.note : '');
      const needs = suv || pos === 'techo'
        ? ['Barras de techo transversales (no incluidas)', `Carga dinámica del techo ≥ ${t.kg} kg`, 'Anclaje propio de la carpa (incluido)']
        : [pos === 'baja' ? 'Soportes de anclaje a las barandas (no incluidos)' : 'Rack de caja alto (no incluido)', 'Anclaje propio de la carpa (incluido)', 'Escalera telescópica (incluida)'];
      root.querySelector('[data-needs]').innerHTML = needs.map((n) => `<li>${n}</li>`).join('');
      const prod = root.querySelector('[data-fit-product]');
      const url = tentInput?.dataset.url;
      prod.hidden = !url || !!root.dataset.locked;
      if (url) prod.href = url;
      prod.textContent = `Ver la ${t.name}`;
      const ask = root.querySelector('[data-fit-ask]');
      const u = new URL(ask.getAttribute('href'), location.origin);
      u.searchParams.set('producto', (url || '').split('/').pop() || tk);
      u.searchParams.set('vehiculo', veh.dataset.name);
      ask.href = u.pathname + u.search;
      verdict.hidden = false;
      verdict.classList.remove('is-in'); void verdict.offsetWidth; verdict.classList.add('is-in');
      preload(veh.value);
      Object.keys(images).filter((k) => k.startsWith(`${veh.value}|${tk}|${color}|`)).forEach((k) => load(images[k]));
    };

    root.addEventListener('change', (e) => {
      if (e.target.name?.startsWith('pk-fit-tent')) drawColors();
      render();
      const lab = e.target.closest('.pk-fit__veh');
      if (lab) lab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
    root.addEventListener('pointerenter', (e) => {
      const v = e.target.closest?.('.pk-fit__veh input, .pk-fit__veh');
      const input = v?.matches('input') ? v : v?.querySelector('input');
      if (input) preload(input.value);
    }, true);
    colorsBox.addEventListener('click', (e) => {
      const b = e.target.closest('[data-color]');
      if (!b) return;
      color = b.dataset.color;
      drawColors();
      render();
    });
    root.querySelectorAll('[data-filter]').forEach((b) => b.addEventListener('click', () => {
      root.querySelectorAll('[data-filter]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      root.querySelectorAll('.pk-fit__veh[data-kind]').forEach((v) => v.classList.toggle('is-hidden', b.dataset.filter !== 'all' && v.dataset.kind !== b.dataset.filter));
      root.querySelector('[data-vehicles]').scrollTo({ left: 0 });
    }));
    root.querySelectorAll('[data-scroll]').forEach((b) => b.addEventListener('click', () => {
      const strip = root.querySelector('[data-vehicles]');
      strip.scrollBy({ left: Number(b.dataset.scroll) * strip.clientWidth * 0.8 });
    }));
    // Celular: hoja con la grilla de vehículos
    const sheet = root.querySelector('[data-fit-sheet]');
    const openBtn = root.querySelector('[data-fit-open]');
    const mobile = matchMedia('(max-width: 989px)');
    const setPick = () => {
      const v = checked('pk-fit-veh');
      if (!openBtn || !v) return;
      openBtn.querySelector('[data-pick-name]').textContent = v.dataset.name;
      openBtn.querySelector('[data-pick-kind]').textContent = v.dataset.kind === 'suv' ? 'SUV y 4x4' : 'Pickup';
      openBtn.querySelector('[data-pick-img]').src = v.closest('label').querySelector('img').src;
    };
    const openSheet = () => {
      if (!sheet) return;
      root.classList.add('is-sheet');
      sheet.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      const cur = checked('pk-fit-veh');
      setTimeout(() => (cur || sheet.querySelector('input')).focus({ preventScroll: true }), 60);
      cur?.closest('label')?.scrollIntoView({ block: 'center' });
    };
    const closeSheet = (focus = true) => {
      if (!sheet || !sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      root.classList.remove('is-sheet');
      openBtn.setAttribute('aria-expanded', 'false');
      if (focus) openBtn.focus({ preventScroll: true });
    };
    openBtn?.addEventListener('click', openSheet);
    root.querySelectorAll('[data-fit-close]').forEach((b) => b.addEventListener('click', () => closeSheet()));
    sheet?.addEventListener('click', (e) => {
      if (mobile.matches && e.target.closest('.pk-fit__veh')) setTimeout(() => closeSheet(), 220);
    });
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSheet(); });
    root.addEventListener('change', (e) => { if (e.target.name?.startsWith('pk-fit-veh')) setPick(); });
    mobile.addEventListener('change', () => closeSheet(false));
    setPick();

    drawColors();
    render();
  });
})();
